import useQuery, { useRevalidate } from "./useQuery";
import type { Input, Output } from "./call";
import React from "react";
import { usePatch } from "./useCall";

export const useClassificationQuantitiesUpdate = () => {
  const updateQuantities = usePatch("/quantities");
  const revalidate = useRevalidate();

  return React.useCallback(
    async (input: Input<"PATCH", "/quantities">) => {
      const res = await updateQuantities(input);
      void revalidate("/quantities");

      return res;
    },
    [revalidate, updateQuantities],
  );
};

export const useClassificationQuantities = (input: Input<"GET", "/quantities">) =>
  useQuery("/quantities", { ...input, keepFresh: true })["body"];

export type ClassificationQuantity = Output<"GET", "/quantities">["body"]["elements"][number];
